// Placeholder error tracking service - will be replaced with full implementation
export const setupErrorTracking = () => {
  console.log('🐛 Error tracking initialized (placeholder)');
};

export const captureError = (error: Error, context?: Record<string, any>) => {
  console.error('Error captured:', error, context);
};

export const captureMessage = (message: string, level: 'info' | 'warning' | 'error' = 'info') => {
  console.log(`[${level.toUpperCase()}] ${message}`);
};

export const trackPerformance = (name: string, operation: () => Promise<any>) => {
  return operation();
};

export const reportError = (error: Error, context?: Record<string, any>) => {
  console.error('Error reported:', error, context);
};

export const trackConversationError = (error: Error, conversationId?: string, action?: string) => {
  console.error('Conversation error:', error, { conversationId, action });
}; 